import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CdkTableModule} from "@angular/cdk/table";

@NgModule({
  imports: [
    CommonModule, MatButtonModule, MatCheckboxModule, MatCardModule, MatIconModule, MatDialogModule, MatInputModule, MatListModule,
    MatMenuModule, MatOptionModule, MatRadioModule, MatSidenavModule, MatSliderModule, MatTooltipModule, MatGridListModule, MatButtonToggleModule,
    MatSnackBarModule, MatSlideToggleModule, MatProgressSpinnerModule, MatProgressBarModule, MatToolbarModule, MatTabsModule, MatTableModule, CdkTableModule, MatSelectModule, MatPaginatorModule

  ],
  exports: [MatButtonModule, MatCheckboxModule, MatCardModule, MatIconModule, MatDialogModule, MatInputModule, MatListModule,
    MatMenuModule, MatOptionModule, MatRadioModule, MatSidenavModule, MatSliderModule, MatTooltipModule, MatGridListModule, MatButtonToggleModule,
    MatSnackBarModule, MatSlideToggleModule, MatProgressSpinnerModule, MatProgressBarModule, MatToolbarModule, MatTabsModule, MatTableModule, CdkTableModule, MatSelectModule, MatPaginatorModule],
  declarations: [],
  schemas: [NO_ERRORS_SCHEMA]
})
export class EDSngCustomMaterialModuleModule { }
